import { tokens } from '@neo4j-ndl/base';
export const breakpoints = {
  '2xl': parseInt(tokens.breakpoints['2xl'].replace('px', '')),
  xl: parseInt(tokens.breakpoints.xl.replace('px', '')),
  lg: parseInt(tokens.breakpoints.lg.replace('px', '')),
  md: parseInt(tokens.breakpoints.md.replace('px', '')),
  sm: parseInt(tokens.breakpoints.sm.replace('px', '')),
  xs: parseInt(tokens.breakpoints.xs.replace('px', '')),
};
